export default [
    {
        value: '1',
        label: '1 Year Subscription'
    },
    {
        value: '2',
        label: '2 Year Subscription'
    },
    {
        value: '3',
        label: '3 Year Subscription'
    },
    {
        value: '4',
        label: '4 Year Subscription'
    },
    {
        value: '5',
        label: '5 Year Subscription'
    },
    {
        value: '6',
        label: '6 Year Subscription'
    },
    {
        value: '7',
        label: '7 Year Subscription'
    },
    {
        value: '8',
        label: '8 Year Subscription'
    }
]
